module.exports = __webpack_public_path__ + "static/media/5-oct14dec14.39834132.pdf";